var Model = require('../Model');

var Building = Object.create(Model);

Building.name = 'Building';
Building['@class'] = 'Building';
Building.url = 'building';
Building.parentClass = 'Location';
Building.fields = {
  parent: {
    default: null,
    hidden: true
  },
  name:{
    type: 'text',
    default: null,
    validators: {
      presence: true, 
      length: {minimum: 1, maximum: 64, default: ''},
    }
  },
  // streetAddress:{
  //   type: 'text',
  //   default: '',
  //   validators: {
  //     presence: true,
  //   }
  // },
  latitude:{
    type: 'number',
    default: '',
    validators: {
      
    }
  },
  longitude:{
    type: 'number',
    default: '',
    validators: {
      
    }
  },
  geojson:{
    type: 'text',
    default: null,
  },
  svg:{
    type: 'text',
    default: null,
  },
  index:{
    default: null,
  },
  defaultMapView: {
    default: null,
    type: 'text',
  }
}

module.exports = Building;
